import { ContainerModule } from 'inversify';
import ApiGlobalConfigService from '../common/apiGlobalConfig/ApiGlobalConfigService';
import { ApiGlobalConfigServiceInterface } from '../common/apiGlobalConfig/ApiGlobalConfigServiceInterface';
import { HttpClientInterface } from 'src/features/http/types';
import HttpClient from 'src/features/http';

export const commonBindings = new ContainerModule((bind) => {
  bind<HttpClientInterface>(HttpClient).to(HttpClient);
  bind<ApiGlobalConfigServiceInterface>(ApiGlobalConfigService).to(
    ApiGlobalConfigService
  );
});
